// ── Cuidado y recuperación: descarga (deload) y bloqueo de progresión ────────
// Los settings viven en usuarios.configuracion (JSON):
//   descarga_hasta:            'YYYY-MM-DD' | '' — fecha fin del periodo de descarga
//   descarga_pct:              número (default 30) — % de reducción de carga
//   bloqueo_progresion_hasta:  'YYYY-MM-DD' | '' — fecha fin del bloqueo de progresión
//   bloqueo_baseline:          { [exName]: { weight, reps, sets } } — techo al activar

export function hoyISO() {
  return new Date().toISOString().split('T')[0];
}

// Descarga activa si hay fecha fin y aún no ha pasado (la fecha fin es inclusive)
export function descargaActiva(settings) {
  const hasta = settings?.descarga_hasta;
  return !!hasta && hoyISO() <= hasta;
}

// El bloqueo explícito y la descarga bloquean progresión (bloqueo implícito)
export function bloqueoActivo(settings) {
  const hasta = settings?.bloqueo_progresion_hasta;
  return (!!hasta && hoyISO() <= hasta) || descargaActiva(settings);
}

// Peso reducido durante descarga, redondeado al múltiplo de 2.5 kg más cercano
// (las cargas del gimnasio solo se ajustan en pasos de 2.5). Ej: 82.5 al 30% → 57.5
export function pesoDescarga(weight, pct) {
  const w = parseFloat(weight);
  if (isNaN(w) || w <= 0) return null;
  const p = parseFloat(pct);
  const reducido = w * (1 - (isNaN(p) ? 30 : p) / 100);
  const redondeado = Math.round(reducido / 2.5) * 2.5;
  return Math.max(2.5, redondeado);
}

// Los ejercicios de peso corporal quedan EXCLUIDOS de la descarga: reducir el
// lastre un % apenas cambia la carga real (peso corporal + lastre), así que no
// tiene sentido fisiológico. La alternativa es sustituirlos por máquina con
// menos peso (el modal ofrece un botón que consulta a FitCoach).
export function esEjPesoCorporal(ex) {
  return ex?.es_peso_corporal === true || ex?.es_peso_corporal === 'true';
}

// Peso de descarga para un ejercicio: null si es de peso corporal (excluido)
export function pesoDescargaEj(ex, pct) {
  if (esEjPesoCorporal(ex)) return null;
  return pesoDescarga(ex?.weight, pct);
}

// Valor techo del baseline para un ejercicio/campo, o null si no hay baseline
export function baselineDe(settings, exName, campo) {
  const base = settings?.bloqueo_baseline?.[exName];
  if (!base || base[campo] === undefined || base[campo] === null || base[campo] === '') return null;
  const n = parseFloat(base[campo]);
  return isNaN(n) ? null : n;
}

// Un ejercicio AÑADIDO durante el periodo (que no estaba en el baseline) queda
// EXENTO de los bloqueos: normalmente sustituye a uno de peso corporal, así que
// no tiene sentido bloquear sus incrementos/ajustes de peso, reps o series.
// Recibe el objeto baseline (settings.bloqueo_baseline). Si el baseline no está
// poblado, no se exime a nadie (se mantiene el bloqueo normal).
export function exentoBloqueoBaseline(baseline, exName) {
  if (!baseline || typeof baseline !== 'object' || Object.keys(baseline).length === 0) return false;
  return !(exName in baseline);
}

// Igual que exentoBloqueoBaseline pero tomando settings directamente.
export function exentoBloqueo(settings, exName) {
  return exentoBloqueoBaseline(settings?.bloqueo_baseline, exName);
}
